import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaginationService {
  getPagination = (headers: PaginationHeader | HttpHeaders): Pagination => {
    return headers instanceof HttpHeaders
      ? this.getPaginationFromHttpHeaders(headers)
      : this.getPaginationFromObject(headers);
  };

  private getPaginationFromHttpHeaders(headers: HttpHeaders): Pagination {
    return {
      total: this.toInt(headers.get('Total')),
      page: this.toInt(headers.get('Current-Page'), 1),
      perPage: this.toInt(headers.get('Per-Page')),
      last: this.toInt(headers.get('Total-Pages'), 1),
    };
  }

  private getPaginationFromObject(paginationHeader: PaginationHeader): Pagination {
    return {
      total: this.toInt(paginationHeader.total),
      page: this.toInt(paginationHeader['current-page'], 1),
      perPage: this.toInt(paginationHeader['per-page']),
      last: this.toInt(paginationHeader['total-pages'], 1),
    };
  }

  private toInt(value: string | null | undefined, fallback = 0): number {
    const parsed = parseInt(value ?? '', 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }
}

export interface Pagination {
  total: number;
  perPage: number;
  page: number;
  last: number;
}

export interface PaginationHeader {
  total: string;
  'per-page': string;
  'total-pages': string;
  'current-page': string;
}
